/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import SectionData from 'components/machine/sectionData';
import React, { ReactNode } from 'react';
import Gauge, { ShowedValue } from '../common/Gauge';
import { SurfaceParameterTypeList } from './SurfaceTypes';

interface SurfaceParameterTypesProps {
  list?: SurfaceParameterTypeList;
}

export default function SurfaceParameterTypes (props: SurfaceParameterTypesProps) {
  const colStyle = 'col-12 col-sm-6 col-md-4';

  const ProcessGauges: ReactNode[] = [];
  if (props.list) {
    for (const key in props.list) {
      const el = props.list[key];
      const value = el.ActualValue?.value;
      const low = el.ActualValue?.properties?.EURange?.low;
      const high = el.ActualValue?.properties?.EURange?.high;

      if (value !== undefined && low !== undefined && high !== undefined) {
        ProcessGauges.push(
          <SectionData cols={colStyle} label={key} key={key}>
            <Gauge min={low} max={high} amount={value} showedValue={ShowedValue.Absolute} />
          </SectionData>
        );
      }
    }
  }
  return <>
    {ProcessGauges}
  </>;
}
